import React from 'react';
import { Container } from 'reactstrap';

import SidebarLayout from '../../components/layout/SidebarLayout';
import PageSkeleton from '../../components/skeleton/PageSkeleton';
import SidebarSkeleton from '../../components/skeleton/SidebarSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const SECTION_PAGE_CHUNK_NAME = 'sectionPage';

export const SectionPageFallback = ({ showSidebarSkeleton }) => {
  return (
    <Container className="SectionPage__container">
      <SidebarLayout
        sidebarPlaceHolder={showSidebarSkeleton ? <SidebarSkeleton /> : null}
        content={<PageSkeleton />}
        contentPlaceHolder={<PageSkeleton />}
      />
    </Container>
  );
};

export const SectionPage = createRouteLoadable(
  () => import(/* webpackChunkName: "sectionPage" */ '../../pages/SectionPage'),
  {
    fallback: <SectionPageFallback showSidebarSkeleton />,
  }
);

export const MobileSectionPage = createRouteLoadable(
  () => import(/* webpackChunkName: "sectionPage" */ '../../pages/SectionPage'),
  {
    fallback: <SectionPageFallback showSidebarSkeleton={false} />,
  }
);
